import { customFooter } from "./custom-footer";

const initFooter = () => {
  const footer = document.querySelector("#footer");

  if (footer) {
    const signature = footer.querySelector("#signature");
    const footerBottom = document.querySelector(".footer-bottom");

    $("#signature").removeAttr("style");

    footerBottom.insertAdjacentHTML("beforebegin", customFooter);

    signature.innerHTML = `
      <span>Vytvořilo</span>
      <a href="https://liffstudio.com/" target="_blank" class="liffstudio">
        Liff Studio
      </a>
      <span>
        na platformě
      </span>
      <a href="https://www.shoptet.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" title="Shoptet" class="title" target="_blank">Shoptet</a>
    `;
  }
};

export { initFooter };
